<template>
    <b-row>
        <b-col class="OTgraphListBlock" v-if="recent_projects.total_count > 0">
            <!-- list with graph -->
            <b-row
                align-v="center"
                v-for="project in recent_projects.resources"
                v-bind:key="project.index"
                class="OTgraphMainGraphLine"
            >
                <b-col class="OTgraphListLabel">
                    <a class="nav-link" :href="'#/projects/' + project.id + '/jobs'">
                        <otif-icon icon="project-list-black" title="Projects" v-b-tooltip.hover />
                        {{ project.get('project_name') }}
                        <br />
                        <span class="OTLandingTitleS4">{{ project.get('modified_date') | moment }}</span>
                    </a>
                    <!--
                    for Later when line graph will be  inside row
                    <b-col class="OTgraphListValue"val</b-col>

              
                <b-col
                    cols="12"
                    class="OTDataCaseBar OTDataCaseBar OTgraphMainGraphLineCellGraph"
                    :class="."
                >
                    <span class="OTGraphsBarOutside">
                        <span
                            class="OTGraphBar"
                            v-bind:style="'width: ' + .graphListValue + '%'"
                        ></span>
                    </span>
                </b-col>
                    -->
                </b-col>
            </b-row>
        </b-col>
        <b-col v-else>
            <b-row>
                <b-col class="OTnoObjectRunning">No projects have been created yet.</b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import ProjectsCollection from "@/collections/projects.js";
import moment from "moment";

export default {
    components: {},
    data() {
        return {
            showProjectsPanel: true,
            recent_projects: new ProjectsCollection()
        };
    },
    filters: {
        moment: function(date) {
            return moment(date).format("D-M-YYYY, h:mm:ss a");
        }
    },
    methods: {
        refresh_projects() {
            this.recent_projects.fetch({
                params: {
                    sort: "modified_date:desc",
                    limit: 5
                }
            });
        }
    },

    mounted() {
        this.refresh_projects();
    }
};
</script>

